import { IconPropsType } from '..';

export const VirtualsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5.23325 4.73335L7.89992 9.35557L6.99992 10.9445L3.42214 4.73335H5.23325ZM8.33325 8.61112L10.5777 4.73335H7.43325V7.04446L8.33325 8.61112ZM12.4666 8.00001C11.9888 10.6445 9.68881 12.5556 7.01103 12.5556C6.6777 12.5556 6.33325 12.5222 5.99992 12.4667C4.54436 12.2 3.27769 11.3778 2.43325 10.1556C1.58881 8.93335 1.26658 7.45557 1.53325 6.00001C2.01103 3.35557 4.31103 1.44446 6.98881 1.44446C7.32214 1.44446 7.66658 1.47779 7.99992 1.53335C9.45547 1.80001 10.7221 2.62224 11.5666 3.84446C12.411 5.06668 12.7333 6.54446 12.4666 8.00001ZM10.8444 4.34446C10.1333 3.32224 9.06658 2.63335 7.84436 2.41112C7.56658 2.35557 7.2777 2.33335 6.99992 2.33335C4.74436 2.33335 2.82214 3.94446 2.41103 6.15557C2.18881 7.37779 2.45547 8.62224 3.16658 9.64446C3.87769 10.6667 4.94436 11.3556 6.16658 11.5889C6.44436 11.6445 6.73325 11.6667 7.01103 11.6667C9.26658 11.6667 11.1888 10.0556 11.5999 7.84446C11.811 6.61112 11.5444 5.37779 10.8444 4.34446Z" />
  </svg>
);
